<template>
    <section id="servicos" class="services section-panel">
        <div class="section-kicker">Serviços</div>
        <h2>Como podemos ajudar?</h2>
        <div class="cards">
            <div class="card">
                <header>
                    <span class="service-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24">
                            <path d="M4 6h16v10H4z" />
                            <path d="M8 20h8M12 16v4M8 10h3M13 10h3M8 13h8" />
                        </svg>
                    </span>
                    <span>Sistemas e aplicativos</span>
                </header>
                <p>
                    Desenvolvimento de plataformas web, aplicativos e integrações desenhadas para
                    processos específicos de cada negócio.
                </p>
            </div>
            <div class="card">
                <header>
                    <span class="service-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24">
                            <path d="M12 4v16M6 8h12M8 14h8" />
                            <path d="M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z" />
                        </svg>
                    </span>
                    <span>Consultoria técnica</span>
                </header>
                <p>
                    Apoio em arquitetura, sustentação, evolução de sistemas, decisões de tecnologia e
                    execução de projetos críticos.
                </p>
            </div>
            <div class="card">
                <header>
                    <span class="service-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24">
                            <path d="M5 12h4l2-7 3 14 2-7h3" />
                            <path d="M4 4h16v16H4z" />
                        </svg>
                    </span>
                    <span>Projetos sob demanda</span>
                </header>
                <p>
                    Times e entregas moldados à necessidade do cliente, da concepção ao lançamento e
                    melhoria contínua.
                </p>
            </div>
        </div>
        <div class="delivery-method">
            <div class="method-copy">
                <div class="section-kicker">Método de entrega</div>
                <h3>Entrega de software com método e menos risco.</h3>
                <p>
                    Trabalhamos em <strong>ciclos curtos</strong>: entendemos o problema, definimos uma arquitetura que
                    possa evoluir e entregamos incrementos testáveis. Usamos práticas modernas e
                    comprovadas de engenharia, como integração contínua, automação de testes, revisão
                    técnica e observabilidade, para levar sistemas da ideia ao do MVP e do MVP à produção com consistência e previsibilidade.
                </p>
            </div>
            <div class="method-cycle" aria-label="Ciclo de desenvolvimento">
                <div class="cycle-step">
                    <span>01</span>
                    <strong>Diagnóstico</strong>
                    <small>contexto, riscos e prioridades</small>
                </div>
                <div class="cycle-line"></div>
                <div class="cycle-step">
                    <span>02</span>
                    <strong>Arquitetura</strong>
                    <small>solução, integrações e plano técnico</small>
                </div>
                <div class="cycle-line"></div>
                <div class="cycle-step">
                    <span>03</span>
                    <strong>Entrega contínua</strong>
                    <small>evolução incremental e suporte</small>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'services'
}
</script>

<style scoped>
.services {
    color: white;

    h2 {
        color: white;
        font-family: "Sora", sans-serif;
        font-size: clamp(2rem, 4vw, 3rem);
        line-height: 1;
        margin-bottom: 1.4rem;
    }

    & .cards {
        display: flex;
        flex-flow: row nowrap;
        gap: 1rem;
        animation: fadeIn 0.751s ease-in;

        .card {
            flex: 1;
            min-width: 0;
            background:
                linear-gradient(145deg, rgba(255, 255, 255, .14), rgba(255, 255, 255, .055)),
                rgba(255, 255, 255, .045);
            border: 1px solid rgba(255, 255, 255, .14);
            border-radius: .5rem;
            padding: 1.2rem;

            header {
                display: flex;
                align-items: center;
                gap: .7rem;
                color: white;
                font-family: "Sora", sans-serif;
                font-size: 1.15rem;
                text-align: left;
                margin-bottom: .65rem;
            }

            p {
                color: rgba(255, 255, 255, .7);
                line-height: 1.6;
            }
        }
    }
}

.service-icon {
    display: inline-grid;
    place-items: center;
    flex: 0 0 auto;
    width: 2.15rem;
    height: 2.15rem;
    border-radius: .5rem;
    background: rgba(255, 255, 255, .1);
}

.service-icon svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.delivery-method {
    display: grid;
    grid-template-columns: minmax(0, .85fr) minmax(28rem, 1fr);
    gap: 1.5rem;
    align-items: center;
    margin-top: 1.35rem;
    padding-top: 1.5rem;
    border-top: 1px solid rgba(255, 255, 255, .12);
}

.method-copy h3 {
    color: white;
    font-family: "Sora", sans-serif;
    font-size: clamp(1.35rem, 3vw, 2rem);
    line-height: 1.15;
    margin-bottom: .8rem;
}

.method-copy p {
    color: rgba(255, 255, 255, .72);
    line-height: 1.65;
}

.method-cycle {
    display: grid;
    grid-template-columns: 1fr auto 1fr auto 1fr;
    gap: .75rem;
    align-items: stretch;
}

.cycle-step {
    min-height: 10rem;
    border: 1px solid rgba(255, 255, 255, .14);
    border-radius: .65rem;
    background:
        linear-gradient(145deg, rgba(255, 255, 255, .13), rgba(255, 255, 255, .045)),
        rgba(255, 255, 255, .035);
    padding: 1rem;
}

.cycle-step span {
    display: inline-grid;
    place-items: center;
    width: 2rem;
    height: 2rem;
    border-radius: 999px;
    background: white;
    color: var(--brand-blue);
    font-weight: 800;
    margin-bottom: .85rem;
}

.cycle-step strong {
    display: block;
    color: white;
    font-family: "Sora", sans-serif;
    font-size: 1rem;
    line-height: 1.25;
    margin-bottom: .4rem;
}

.cycle-step small {
    color: rgba(255, 255, 255, .66);
    line-height: 1.45;
}

.cycle-line {
    width: 2.2rem;
    height: 2px;
    align-self: center;
    background: linear-gradient(90deg, rgba(255, 255, 255, .2), rgba(255, 255, 255, .75));
}

@media screen and (max-width: 820px) {
    .services {
        & .cards {
            flex-direction: column;
            gap: .85rem;
        }

        & .cards .card + .card {
            border-top-color: rgba(255, 255, 255, .28);
        }
    }

    .delivery-method {
        grid-template-columns: 1fr;
    }

    .method-cycle {
        grid-template-columns: 1fr;
    }

    .cycle-step {
        min-height: auto;
        padding: .9rem 1rem;
    }

    .cycle-step span {
        display: inline-grid;
        vertical-align: middle;
        margin: 0 .65rem 0 0;
    }

    .cycle-step strong {
        display: inline;
        vertical-align: middle;
        margin-bottom: 0;
    }

    .cycle-step small {
        display: block;
        margin-top: .45rem;
        padding-left: 2.65rem;
    }

    .cycle-line {
        width: 2px;
        height: 1rem;
        justify-self: center;
        background: linear-gradient(180deg, rgba(255, 255, 255, .2), rgba(255, 255, 255, .75));
    }
}
</style>
